export default __webpack_public_path__ + "static/media/ideas_4.0f39f90d.png";